import { useEffect, useState } from 'react';
import Mobile from './MobileBar';
import Desktop from './DesktopBar';
import { useSelector } from 'react-redux';

const Navbar = () => {

    // Check isLogged
    const { isLogged, id, user, email, level } = useSelector(state => state.user);

    // Check window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    }
    useEffect(() => {
        window.addEventListener("resize", handleResize);
        // Clean up the listener in component amount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [])
    return (
        <div className='w-full flex justify-center'>
            {windowWidth <= 768 && <Mobile isLogged={isLogged} level={level} />}
            {windowWidth > 768 && <Desktop isLogged={isLogged} user={user} level={level} />}
        </div>
    )
}

export default Navbar;